




















import { Vue, Prop, Component, Watch } from 'vue-property-decorator';

@Component
export default class LackOfMovementConfig extends Vue {
  @Prop()
  public value: any;

  @Watch('value', { immediate: true })
  public onValChange(): void {
      if (!this.value) {
          this.$emit('input', {});
      }
  }
}
